import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import {authGuard} from './guard'

declare module 'vue-router' {
    interface RouteMeta {
        breadcrumb?: string;
        requiresAuth?: boolean;

        [key: string]: unknown;
    }
}

const routes: Array<RouteRecordRaw> = [
    {
        path: '/auth/callback',
        name: 'AuthCallback',
        component: () => import('@/pages/AuthCallback.vue'),
        meta: {breadcrumb: 'Authentication'}
    },
    {
        path: '/integration',
        name: 'IntegrationView',
        component: () => import('@/pages/IntegrationPage.vue'),
        meta: {breadcrumb: 'Integration'}
    },
    {
        path: '/',
        component: () => import('@/components/layout/SidebarLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'DashboardView',
                component: () => import('@/pages/HomePage.vue'),
                meta: {breadcrumb: 'Dashboard'}
            },
            {
                path: 'websites',
                name: 'WebsitesView',
                component: () => import('@/pages/Website/WebsiteDashboard.vue'),
                meta: {breadcrumb: 'Websites'}
            },
            {
                path: 'documents',
                name: 'DocumentsView',
                component: () => import('@/pages/Document/DocumentDashboard.vue'),
                meta: {breadcrumb: 'Documents'}
            },
            {
                path: 'documents/preview/:slug',
                name: 'DocumentPreview',
                component: () => import('@/pages/Document/DocumentPreview.vue'),
                meta: {breadcrumb: 'Documents'},
            },
            {
                path: 'documents/create',
                name: 'DocumentsCreateView',
                component: () => import('@/pages/Document/DocumentCreate.vue'),
                meta: {breadcrumb: 'Documents'}
            },
            {
                path: 'documents/view/:slug',
                name: 'DocumentView',
                component: () => import('@/pages/Document/DocumentEdit.vue'),
                meta: {breadcrumb: 'Documents'},
            },
            {
                path: 'websites/create',
                name: 'WebsiteCreateView',
                component: () => import('@/pages/Website/WebsiteDashboard.vue'),
                meta: {
                    breadcrumb: 'Websites',
                },
                props: {openCreateForm: true}
            },
            {
                path: 'websites/view/:id',
                name: 'WebsiteView',
                component: () => import('@/pages/Website/WebsiteView.vue'),
                meta: {breadcrumb: 'Websites'},
                props: true
            },
            {
                path: 'specific-rules',
                name: 'SpecificRulesView',
                component: () => import('@/pages/SpecificRulesPage.vue'),
                meta: {breadcrumb: 'Specific Rules'}
            },
            {
                path: '/:pathMatch(.*)*',
                name: 'NotFoundView',
                component: () => import('@/pages/NotFoundPage.vue'),
                meta: {breadcrumb: 'Not Found'}
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return {top: 0}
    }
})

router.beforeEach(authGuard)

export default router